export default "__VITE_ASSET__88dac7eb__"